export default [
  {
    name: 'getBxcpList',
    method: 'get',
    desc: '获取保险列表',
    path: '/obt/getBxcpList',
    params: {
      cplx: ''
    }
  }, {
    name: 'getBxOrder',
    method: 'get',
    desc: '根据订单id获取保险详情',
    path: '/obt/getBxOrder',
    params: {
      glddId: ''
    }
  }, {
    name: 'bookBx',
    method: 'post',
    desc: '保险下单（查询预定时用）',
    path: '/obt/bookBx',
    params: {
      bxcpList: [{
        bxid: '',
        bxmc: '',
        bxxz: '',
        bxxzmc: '',
        saleprice: '',
        sxgz: '',
        cpsm: ''
      }],
      cplx: '10901',
      orderId: ''
    }
  }, {
    name: 'getBxOrderListByGlddId',
    method: 'get',
    desc: '根据关联订单id获取保险订单列表',
    path: '/obt/getBxOrderListByGlddId',
    params: {
      glddId: ''
    }
  }, {
    name: 'getBdUrl',
    method: 'get',
    desc: 'OBT保单下载',
    path: '/obt/bx/order/bdDownload',
    params: {
      glddId: ''
    }
  },

]